<div class="pl-4 pr-1 pt-2 sticky top-0 z-50 bg-white">
    <div class="mt-1 mr-2 flex items-center gap-1">
        <app-search-lazy
            class="flex-1"
            [hasResults]="!!searchString"
            [isLoading]="isSearching"
            [searchString]="searchString"
            [placeholder]="'Search in Navigation Tree...'"
            (searchEvent)="onSearchEvent($event)"
        />
        @if (hasExpandedNodes()) {
            <p-button
                class="collapse-btn"
                icon="pi pi-arrow-down-left-and-arrow-up-right-to-center"
                variant="text"
                severity="secondary"
                pTooltip="Collapse all"
                [showDelay]="500"
                (onClick)="collapseAll()"
            />
        }
    </div>
</div>

<p-tree
    scrollHeight="100%"
    loadingMode="icon"
    [value]="nodes"
    (onNodeExpand)="onNodeExpand($event)"
>
    <!-- Anchor row -->
    <ng-template let-node pTemplate="anchor">
        <div
            #anchorRow
            class="flex justify-between items-center p-0"
            [attr.data-anchor-key]="node.data?.anchor?.key"
            (contextmenu)="onClickTieredMenu($event, node, anchorRow)"
        >
            <div class="flex min-w-0 items-center gap-2">
                @if (node.styleClass?.includes('newly-created-anchor')) {
                    <span class="new-anchor-badge">NEW</span>
                }
                <span class="min-w-0">
                    <app-highlight-text
                        [text]="node.label"
                        [searchTerm]="searchString"
                        matchMode="fuzzy"
                    />
                </span>
            </div>
            @if (hasMenuItems(node)) {
                <p-button
                    class="more-btn"
                    icon="pi pi-ellipsis-v"
                    [rounded]="true"
                    variant="text"
                    pTooltip="Actions"
                    [showDelay]="500"
                    severity="secondary"
                    (onClick)="onClickTieredMenu($event, node, anchorRow)"
                    size="small"
                />
            }
        </div>
    </ng-template>

    <!-- AnchorType -->
    <ng-template let-node pTemplate="anchorType">
        <div
            #anchorTypeRow
            class="flex justify-between items-center p-0"
            (contextmenu)="onClickTieredMenu($event, node, anchorTypeRow)"
        >
            <span [ngClass]="{ 'text-500': node.leaf }">{{ node.label }}</span>
            <p-button
                [disabled]="!hasMenuItems(node)"
                class="more-btn"
                icon="pi pi-ellipsis-v"
                [rounded]="true"
                variant="text"
                pTooltip="Actions"
                severity="secondary"
                (onClick)="onClickTieredMenu($event, node, anchorTypeRow)"
                size="small"
            />
        </div>
    </ng-template>

    <ng-template let-node pTemplate="noResults">
        <span class="text-surface-500 dark:text-surface-300 p-1">{{ node.label }}</span>
    </ng-template>

    <!-- Load More -->
    <ng-template let-node pTemplate="loadMore">
        <div
            class="flex items-center gap-2 py-2 cursor-pointer text-primary"
            (click)="!node.loading && loadMoreAnchors(node)"
        >
            @if (!node.loading) {
                <i class="pi pi-plus-circle"></i>
            }
            @if (node.loading) {
                <i class="pi pi-spin pi-spinner"></i>
            }
            <span>{{ node.label }}</span>
        </div>
    </ng-template>
</p-tree>

<app-crud-address-modal #addressModal></app-crud-address-modal>
<app-crud-allocation-element-modal #allocationElementModal></app-crud-allocation-element-modal>
<app-crud-allocation-element-diagram-modal
    #allocationElementDiagramModal
></app-crud-allocation-element-diagram-modal>
<app-crud-component-code-modal #componentCodeModal></app-crud-component-code-modal>
<app-crud-component-modal #componentModal></app-crud-component-modal>
<app-crud-function-category-modal #functionCategoryModal></app-crud-function-category-modal>
<app-crud-message-modal #messageModal></app-crud-message-modal>
<app-crud-scenario-modal #scenarioModal></app-crud-scenario-modal>
<app-crud-segment-modal #segmentModal></app-crud-segment-modal>
<app-crud-signal-modal #signalModal></app-crud-signal-modal>
<app-crud-use-case-modal #useCaseModal></app-crud-use-case-modal>
<app-crud-user-function-modal #userFunctionModal></app-crud-user-function-modal>
<app-change-request-details #changeRequestDetailsModal></app-change-request-details>
<app-workspace-dialog #workspaceDialog></app-workspace-dialog>

<p-tieredmenu #menu [model]="menuItems" [popup]="true" styleClass="" />
